import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "status-tag" }
const _hoisted_2 = {
  key: 0,
  class: "text-muted font-size-mini"
}

import {localeDateTimeString} from "~/core-ui/ts/CoreUiHelpersMixin";


const __default__ = {
    name: "StatusTag"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    descr: {},
    color: {},
    dateTime: {},
    customClass: {},
    effect: { default: 'plain' },
    size: { default: 'large' }
  },
  setup(__props: any) {

let props = __props;

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_tag, {
      effect: __props.effect && __props.effect.length ? __props.effect : undefined,
      class: _normalizeClass([`text-${__props.color}`, `border-${__props.color}`, __props.customClass]),
      title: __props.descr,
      size: __props.size
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(__props.descr), 1)
      ]),
      _: 1
    }, 8, ["effect", "class", "title", "size"]),
    (__props.dateTime)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(localeDateTimeString)(__props.dateTime)), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})